import { ThemeProvider, useTheme } from '@mui/material';
import { GoogleOAuthProvider } from '@react-oauth/google';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import './App.css';
import './styles/styles.css';
import theme from './mui-theme';
import Router from './router';
import { QueryClientProvider } from '@tanstack/react-query';
import queryClient from './lib/queryClient';
import { JiraBroadcastListener } from './lib/broadcastChannels';
import MaintenancePage from './pages/MaintenancePage'; 

function App() {
  const muiTheme = useTheme();
 if (process.env.REACT_APP_MAINTENANCE_MODE === 'true') return <MaintenancePage />;
  return (
    <ThemeProvider theme={{ ...muiTheme, theme }}>
      <GoogleOAuthProvider
        clientId={process.env.REACT_APP_GOOGLE_OAUTH_CLIENT_ID}>
        <QueryClientProvider client={queryClient}>
          <Router />
          <JiraBroadcastListener />
        </QueryClientProvider>
      </GoogleOAuthProvider>
    </ThemeProvider>
  );
}

export default App;
